import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@material-ui/core';

function AmberButton({ children, onClick, disabled, testid }) {
  return (
    <Button
      data-testid={testid}
      disabled={disabled}
      onClick={onClick}
      variant="contained"
      color="primary"
    >
      {children}
    </Button>
  );
}

AmberButton.propTypes = {
  children: PropTypes.node,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  testid: PropTypes.string,
};

AmberButton.defaultProps = {
  children: null,
  onClick: null,
  disabled: false,
  testid: '',
};

export default AmberButton;
